import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';

import { SortableMenuItemList } from './SortableMenuItemList';

class MenuItemsColumn extends Component {
    render() {
        const { titleColumn, titleColumnRow, titleColumnRowCol, flexCenter, rowStyle } = this.props.styles;
        const { column, renderTitleRow, renderTitleParagraph } = this.props;

        return (
            <Col style={titleColumn} className="menuItemsColumn" id={`${column}-column`}>
                <Row style={titleColumnRow}>
                    <Col sm={8} id={`${column}-column-paragraph`} style={titleColumnRowCol}>
                        {renderTitleParagraph}
                    </Col>
                    <Col id={`${column}-column-icon`} hidden={this.props.hiddenRow || this.props.posNotConfigured} style={flexCenter}>
                        {renderTitleRow}
                    </Col>
                </Row>
                <Row style={rowStyle}>
                    <SortableMenuItemList
                        distance={20}
                        helperClass={'menu-config-item-active'}
                        restaurantId={this.props.restaurantId}
                        items={this.props.items}
                        activeItem={this.props.activeItem}
                        onSelect={this.props.onSelect}
                        onSortEnd={this.props.onReorder}
                        renderTitleRow={this.props.renderTitleRow}
                        renderActionComponent={this.props.renderActionComponent}
                        sortDisabled={this.props.sortDisabled}
                        column={this.props.column}
                        styles={this.props.styles}
                    />
                </Row>
            </Col>
        );
    }
}

export default MenuItemsColumn;


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/MenuItemsColumn.js